import * as yup from 'yup';
import { getPasswordStrength, PasswordStrength } from './passwordStrength';

export const getEmailSchema = () =>
  yup
    .string()
    .email('component.userProfileSettings.invalidEmail')
    .required('component.userProfileSettings.emailAddressRequired');

export const getOptionalEmailSchema = () =>
  yup.string().email('component.userProfileSettings.invalidEmail').optional();

export const getPasswordSchema = (checkStrength?: boolean) => {
  const schema = yup.string().required('general.required');
  return checkStrength
    ? schema.test(
        'strong',
        'component.PasswordStrengthIndicator.description',
        async (val) => {
          const strength = await getPasswordStrength(val);
          return [PasswordStrength.GOOD, PasswordStrength.STRONG].includes(
            strength,
          );
        },
      )
    : schema;
};

type ChangeEmailInputs = {
  email: string;
};

export const getChangeEmailSchema = () => {
  return yup.object<ChangeEmailInputs>().shape({
    email: getEmailSchema(),
  });
};
